import { BrickContext, VisualBrick, registerBrick } from 'olympe';
import * as d3 from 'd3';
import { combineLatest } from 'rxjs';

export default class Bar60Chart extends VisualBrick {
    protected setupExecution($: BrickContext) {
        const observeData = $.observe('data');
        const observeWidth =  $.observe('Width');
        
        return combineLatest([
          observeData,
          observeWidth,
        ]);

    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @return {Element}
     */
    render($: BrickContext, [data_array]) {
        // Write your code here. This method must return a DOM element.
        // If using React take a look at the ReactBrick class.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed only once by default.
        // Override `setupExecution()` to change the behavior and control the `properties` parameter.
        const width: number = $.get("Width");
        const height: number = $.get("Height");
        const marginTop = 20;
        const marginRight = 30;
        const marginBottom = 30;
        const marginLeft = 30;

        const data = data_array.flatMap((v,i) => {
            return [{"ts":i, "tag": "nominal", "num":v.nominal},
                    {"ts":i, "tag": "warn", "num":v.warn},
                    {"ts":i, "tag": "anomaly", "num":v.anomaly},
                    {"ts":i, "tag": "unknown", "num":v.unknown}]
                });
        const colors = new Map([
            ["unknown", "#BBB1AC"],
            ["anomaly", "#E1575A"],
            ["warn", "#F1CF63"],
            ["nominal", "#B4E0A7"]
          ])

        const series = d3.stack()
                         .keys(colors.keys())
                         .value((group, key) => group.get(key).num)
                         .order(d3.stackOrderReverse)
                       (d3.rollup(data, ([d]) => d, d => d.ts, d => d.tag).values())
                       .map(s => (s.forEach(d => d.data = d.data.get(s.key)), s))
      
        // Create scales.
        const x = d3.scaleBand()
            .domain(data.map(d => d.ts))
            .rangeRound([marginLeft, width - marginRight]);
      
        const y = d3.scaleLinear()
            .domain([0, d3.max(series, d => d3.max(d, d => d[1]))]).nice()
            .range([height - marginBottom, marginTop]);
      
        const color = d3.scaleOrdinal()
            .domain(colors.keys())
            .range(colors.values());
      
        // Create the SVG container.
        const svg = d3.create("svg")
            .attr("viewBox", [0, 0, width, height])
            .attr("width", width)
            .attr("height", height)
            .attr("style", "max-width: 100%; height: auto;");
      
        // Create the bars.
        const formatRevenue = x => x;
      
        svg.append("g")
          .selectAll("g")
          .data(series)
          .join("g")
            .attr("fill", ({key}) => color(key))
            .call(g => g.selectAll("rect")
              .data(d => d)
              .join("rect")
                .attr("x", d => x(d.data.ts))
                .attr("y", d => y(d[1]))
                .attr("width", x.bandwidth() - 1)
                .attr("height", d => y(d[0]) - y(d[1]))
             .append("title")
                .text(d => `${d.data.tag}, ${d.data.num}`));
      
        // Create axes.
        svg.append("g")
            .attr("transform", `translate(0,${height - marginBottom})`)
            .call(d3.axisBottom(x)
                .tickValues(d3.ticks(...d3.extent(x.domain()), width / 80))
                .tickSizeOuter(0));
      
        svg.append("g")
            .attr("transform", `translate(${marginLeft},0)`)
            .call(d3.axisLeft(y)
                .tickFormat(x => x))
            .call(g => g.select(".domain").remove())
            .call(g => g.select(".tick:last-of-type text").clone()
                .attr("x", 3)
                .attr("text-anchor", "start")
                .attr("font-weight", "bold")
                .text("Number of events"));
      
        return svg.node();
    }
}

registerBrick('0190973863e2516dd574', Bar60Chart);
